import { makeApiRequest } from 'actions/api';
import RequestService from 'services/RequestService';

export const GET_RECOMMENDED_MEALS_FOR_BASKET = 'GET_RECOMMENDED_MEALS_FOR_BASKET';
export const GET_RECOMMENDED_MEALS_FOR_BASKET_REQUEST = 'GET_RECOMMENDED_MEALS_FOR_BASKET_REQUEST';
export const GET_RECOMMENDED_MEALS_FOR_BASKET_RESPONSE =
  'GET_RECOMMENDED_MEALS_FOR_BASKET_RESPONSE';
export const GET_RECOMMENDED_MEALS_FOR_BASKET_ERROR = 'GET_RECOMMENDED_MEALS_FOR_BASKET_ERROR';

export const getRecommendedMealsForBasket = (menuSlug, extrasStage = false) =>
  makeApiRequest({
    requestType: GET_RECOMMENDED_MEALS_FOR_BASKET,
    method: RequestService.getRecommendedMealsForBasket,
    params: { menuSlug, extrasStage },
  });
